import { BasicTypeaheadComponent } from './typeaheads/tactics/basic-typeahead.component';
import { NgModule } from '@angular/core';
import { TypeaheadModule } from 'ngx-bootstrap';

import { NgxDatatableModule } from "@swimlane/ngx-datatable";

import { TypeaheadLookupComponent } from './typeahead-lookup-component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppDatatableModule } from '../datatable';
import { CampaignBrandsTypeaheadComponent } from './typeaheads/campaign-brands-typeahead.component';
import { CampaignThemeCategoriesTypeaheadComponent } from './typeaheads/campaign-theme-categories-typeahead.component';
import { RetailersTypeaheadComponent } from './typeaheads/retailers-typeahead.component';
import { StrategicBusinessInitiativesTypeaheadComponent } from './typeaheads/strategic-business-initiatives-typeahead.component';
import { BudgetYearTypeaheadComponent } from './typeaheads/budget-year-typeahead.component';
import { DeliveryMethodsTypeaheadComponent } from './typeaheads/delivery-methods-typeahead.component';
import { StatesTypeaheadComponent } from './typeaheads/states-typeahead.component';
import { CountriesTypeaheadComponent } from './typeaheads/countries-typeahead.component';

@NgModule({
    declarations: [
        TypeaheadLookupComponent,
        CampaignBrandsTypeaheadComponent,
        CampaignThemeCategoriesTypeaheadComponent,
        RetailersTypeaheadComponent,
        StrategicBusinessInitiativesTypeaheadComponent,
        BudgetYearTypeaheadComponent,
        DeliveryMethodsTypeaheadComponent,
        StatesTypeaheadComponent,
        CountriesTypeaheadComponent,
        BasicTypeaheadComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgxDatatableModule,
        AppDatatableModule,
        TypeaheadModule.forRoot()
    ],
    exports: [
        CampaignBrandsTypeaheadComponent,
        CampaignThemeCategoriesTypeaheadComponent,
        RetailersTypeaheadComponent,
        StrategicBusinessInitiativesTypeaheadComponent,
        BudgetYearTypeaheadComponent,
        DeliveryMethodsTypeaheadComponent,
        StatesTypeaheadComponent,
        CountriesTypeaheadComponent,
        BasicTypeaheadComponent
    ],
    providers: []
})
export class AppTypeaheadModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/typeahead/typeahead.module.ts